export default __webpack_public_path__ + "f0756aaa6a969d2bfab60b2604c2db93.jpg";